import { render } from "./sign_in_dialog_content.vue?vue&type=template&id=6508e9c8&ts=true"
import script from "./sign_in_dialog_content.vue?vue&type=script&lang=ts"
export * from "./sign_in_dialog_content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__